import script from "./FretboardDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./FretboardDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./FretboardDisplay.vue?vue&type=style&index=0&id=095f810c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095f810c"]])

export default __exports__